import { Avatar, Box, Circle, HStack, Text } from '@chakra-ui/react';

import { useAuthStore } from '@/client/services/state/authStore';
import { useLearnerDashboard } from '../hooks/useLearnerDashboard';
import { useNavigate } from 'react-router-dom';

// TODO: Location data for a user is not something that is set by default, we could possibly take the first location in privacy_locations, if they have one and look that up.

export default function LearnerDashboardSideNavigation() {
  const { navItems } = useLearnerDashboard();
  const { authConfig } = useAuthStore();
  const { user } = authConfig;
  const navigate = useNavigate();

  return (
    <>
      <HStack spacing={2} paddingTop={6} paddingX={4} paddingBottom={4}>
        <Avatar
          name={user.full_name}
          src={user.image}
          borderRadius="7px"
          size="md"
          backgroundColor="neutral.100"
          color="baseBlack"
        />

        <Text size="14px" fontWeight={600} color="baseBlack">
          {user.full_name}
        </Text>
      </HStack>

      <Box
        border="1px solid"
        borderColor="neutral.100"
        borderRadius="8px"
        backgroundColor="neutral.0"
        paddingY={6}
        paddingX={4}
        marginX={2}
        marginBottom={2}
      >
        {navItems.map((item) => (
          <HStack
            key={item.label}
            spacing={2}
            padding={2}
            borderRadius="8px"
            _hover={{ cursor: 'pointer', backgroundColor: 'neutral.100' }}
            transition="background-color 400ms"
            onClick={() => navigate(item.route)}
          >
            <item.icon color="baseBlack" />

            <Text size="14px" fontWeight={500} color="baseBlack">
              {item.label}
            </Text>

            {item.count && (
              <Circle
                size="25px"
                backgroundColor="neutral.0"
                border="1px solid"
                borderColor="neutral.200"
              >
                <Text fontSize="10px" fontWeight={600} color="neutral.1200">
                  {item.count}
                </Text>
              </Circle>
            )}
          </HStack>
        ))}
      </Box>
    </>
  );
}
